import { createContext, Dispatch, SetStateAction, useState } from 'react';

export interface ILayoutProvider {
  prevetCloseRightMenu: boolean;
  showEnableLocationModal: boolean;
  showGuideToEnableLocation: boolean;

  changeStatusCloseMenu: (option: boolean) => void;
  openCloseLocationModal: () => void;
  setShowGuideToEnableLocation: Dispatch<SetStateAction<boolean>>;
}

export const LayoutContext = createContext<ILayoutProvider>(
  {} as ILayoutProvider
);

export const LayoutContextProvider = (props: any) => {
  /**
   * Este estado controla si el menu de la derecha puede cerrarse
   *  por la funcion de hacer click fuera de su entorno
   */
  const [prevetCloseRightMenu, setPrevetCloseRightMenu] =
    useState<boolean>(false);

  /**
   * Cambiar el valor al estado  prevetCloseRightMenu
   * @param option Valor que se le asigna al estado que controla la prevencion del cerrado del menu
   */
  const changeStatusCloseMenu = (option: boolean) => {
    setPrevetCloseRightMenu(option);
  };

  const [showEnableLocationModal, setShowEnableLocationModal] =
    useState<boolean>(false);

  function openCloseLocationModal() {
    setShowEnableLocationModal(!showEnableLocationModal);
    setShowGuideToEnableLocation(false);
  }

  const [showGuideToEnableLocation, setShowGuideToEnableLocation] =
    useState<boolean>(false);

  return (
    <LayoutContext.Provider
      value={{
        prevetCloseRightMenu,
        showEnableLocationModal,
        showGuideToEnableLocation,

        setShowGuideToEnableLocation,

        changeStatusCloseMenu,
        openCloseLocationModal,
      }}>
      {props.children}
    </LayoutContext.Provider>
  );
};
